/**
 * Static configuration data for filters
 * This data should ideally come from an API or environment config
 * Extracted from common-options.ts to improve maintainability
 */

export const STATIC_FILTER_DATA = {
  stores: [
    { value: "all", label: "All Stores" },
    { value: "downtown_store_sf", label: "Downtown Store SF" },
    { value: "oakland_food_truck", label: "Oakland Food Truck" },
    { value: "westfield_mall", label: "Westfield Mall" },
    { value: "farmers_market_stand", label: "Farmers Market Stand" },
    { value: "coffee_shop_oakland", label: "Coffee Shop Oakland" },
    { value: "sfo_terminal_1", label: "SFO Terminal 1" },
    { value: "delivery_fleet_sf", label: "Delivery Fleet SF" },
    { value: "italian_bistro_sf", label: "Italian Bistro SF" },
    { value: "fashion_store_oakland", label: "Fashion Store Oakland" },
    { value: "shell_station_sj", label: "Shell Station SJ" },
    { value: "city_pharmacy_sf", label: "City Pharmacy SF" },
    { value: "fresh_market_sf", label: "Fresh Market SF" },
    { value: "grand_hotel_sf", label: "Grand Hotel SF" },
    { value: "corner_bookstore_sf", label: "Corner Bookstore SF" },
    { value: "beauty_salon_sf", label: "Beauty Salon SF" },
    { value: "fitness_center_sf", label: "Fitness Center SF" },
    { value: "mall_kiosk_sf", label: "Mall Kiosk SF" },
    { value: "auto_wash_sf", label: "Auto Wash SF" },
    { value: "corner_bakery_sf", label: "Corner Bakery SF" },
    { value: "wash_dry_sf", label: "Wash & Dry SF" },
    { value: "pet_paradise_sf", label: "Pet Paradise SF" },
    { value: "tools_more_sf", label: "Tools & More SF" },
    { value: "taco_truck_oakland", label: "Taco Truck Oakland" },
    { value: "flower_shop_sf", label: "Flower Shop SF" },
    { value: "diamond_palace_sf", label: "Diamond Palace SF" },
    { value: "vision_center_sf", label: "Vision Center SF" },
    { value: "tech_hub_sf", label: "Tech Hub SF" },
    { value: "footwear_plus_sf", label: "Footwear Plus SF" },
    { value: "kids_paradise_sf", label: "Kids Paradise SF" },
    { value: "sports_world_sf", label: "Sports World SF" },
    { value: "melody_shop_sf", label: "Melody Shop SF" },
    { value: "gallery_modern_sf", label: "Gallery Modern SF" },
    { value: "vintage_finds_sf", label: "Vintage Finds SF" },
    { value: "vine_dine_sf", label: "Vine & Dine SF" },
  ],
  
  locations: [
    { value: "all", label: "All Locations" },
    { value: "downtown_store", label: "Downtown Store" },
    { value: "food_truck", label: "Food Truck" },
    { value: "westfield_mall", label: "Westfield Mall" },
    { value: "farmers_market", label: "Farmers Market" },
    { value: "storage_room", label: "Storage Room" },
    { value: "coffee_shop_drive_thru", label: "Coffee Shop Drive-thru" },
    { value: "airport_terminal_1", label: "Airport Terminal 1" },
    { value: "delivery_van_3", label: "Delivery Van #3" },
    { value: "italian_bistro", label: "Italian Bistro" },
    { value: "fashion_store", label: "Fashion Store" },
    { value: "shell_station", label: "Shell Station" },
    { value: "city_pharmacy", label: "City Pharmacy" },
    { value: "fresh_market", label: "Fresh Market" },
    { value: "grand_hotel", label: "Grand Hotel" },
  ],
}

/**
 * Get static data for a specific filter type
 * @param dataType The type of static data to retrieve
 * @returns The static data array or empty array if not found
 */
export function getStaticFilterData(dataType: keyof typeof STATIC_FILTER_DATA) {
  return STATIC_FILTER_DATA[dataType] || []
}